module.exports = __webpack_public_path__ + "static/media/HEART-4.57946fea.svg";